import {trackEvent} from '@/services/tracking.js';
import {isJwtExpired} from '@/services/jwt';

export function getSelectedProducts(step) {
	const productIds = step.selected?.map((el) => +el?.initial);
	if (!step.products || !step.stepEnabled || (!!productIds && !productIds.length)) return [];
	return step.products.filter((el) => productIds.includes(+el.pimId));
}
export function getPriceProduct(prod, countryCode, isLogin) {
	if (!prod || !countryCode) return 0;
	if (prod?.customContent && prod?.customContent?.customProduct) return 0;
	const priceStatus = prod.priceStatuses[countryCode];
	if (
		prod.itemType === 'GeneGlobe' ||
		(priceStatus === 'Login' && !isLogin) ||
		(priceStatus !== 'Display' && priceStatus !== 'Login')
	)
		return 0;
	const priceCountry = prod.prices.find((el) => el.countryIsoCode === countryCode);
	return priceCountry?.price?.custom || priceCountry?.price?.value || 0;
}

export default {
	computed: {
		productListWithPrices() {
			const isLogin = !isJwtExpired();
			return this.$store.getters['workflow/wfSteps'].reduce((arr, step) => {
				const country = this.getCountry;
				const products = getSelectedProducts(step);
				products.forEach((product) => {
					const price = getPriceProduct(product, country, isLogin);
					if (price) arr.push({product, price});
				});

				return arr;
			}, []);
		},
		totalProductPrice() {
			return this.productListWithPrices.reduce((sum, product) => sum + product.price, 0);
		},
		allProductsForCartButton() {
			return this.productListWithPrices.map((p) => ({
				CatalogNumber: p?.product?.catalogNumber.toString(),
				Quantity: 1,
			}));
		},
	},
	watch: {
		totalProductPrice(newValue, oldValue) {
			// hide snackbar if Total price != 0
			if (!oldValue && newValue) this.$snackbar();
		},
	},
	methods: {
		addAllProductsToCart() {
			// check total price
			if (!this.totalProductPrice) {
				this.$snackbar({title: 'There are no products to add to cart.'});
				return;
			}
			trackEvent('ctaClick', {eVar58: 'Add products to cart  | Workflow Configurator'});

			// trigger click on button inside web compnent (to add all products)
			this.$refs['add-all-cta']?.querySelector('a,button')?.click();
		},
	},
};
